import { Pipe, PipeTransform } from '@angular/core';

/**
 * Find Language From Key
 * @description Angular pipe for retrieve the language used for I18N
 */

@Pipe({ name: 'findLanguageFromKey' })
export class FindLanguageFromKeyPipe implements PipeTransform {
  private readonly languages: { [key: string]: { name: string; rtl?: boolean } } = {
    en: { name: 'english' },
    it: { name: 'italian' },
    es: { name: 'spanish' },
    fr: { name: 'french' },
    zu: { name: 'crowdin' }
    // add/remove languages in this object
  };

  /**
   * Convert language key in the relative language string
   * @param lang The key to search
   */
  transform(lang: string): string {
    return this.languages[lang].name;
  }
}
